<div class="container">

    <section class='header'>
        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div>
                <mat-icon style='margin-top:10px; font-size:.9em;'>business</mat-icon>
                <div style='display:inline-block; margin-left:10px;'>
                    Documento
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar>
    </section>

    <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <div class='tab-content'>

            <mat-form-field class="full-width">
                <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
                    placeholder="Nome" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                    O Nome é obrigatório
                </mat-error>
            </mat-form-field>

            <div style='height: 380px; width: 760px; font-size: 2em;'>
                <quill-editor format='html' [formControl]="entityForm.controls.html">
                </quill-editor>
            </div>
        </div>

    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class="icon-done">check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
    </div>

</div>